import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { base_url } from "../../../base_urls";

const RecentFiles = () => {
  const [values, setValues] = useState([]);

  useEffect(() => {
    axios
      .get(base_url + "api/recentfiles.json")
      .then((res) => setValues(res.data))
      .catch((err) => console.log(err));
  }, []);

  return (
    <div className="row row-sm">
      {values.map((file, index) => (
        <div className="col-6 col-sm-4 col-md-3 col-lg-4 col-xl-3" key={index}>
          <div className="card card-file">
            <div className="dropdown-file">
              <Link
                to="#"
                className="dropdown-link  "
                data-bs-toggle="dropdown"
              >
                <i className="fa fa-ellipsis-v" />
              </Link>
              <div className="dropdown-menu dropdown-menu-right text-end">
                <Link to="#" className="dropdown-item">
                  عرض التفاصيل
                </Link>
                <Link to="#" className="dropdown-item">
                  مشاركة
                </Link>
                <Link to="#" className="dropdown-item">
                  تحميل
                </Link>
                <Link to="#" className="dropdown-item">
                  إعادة تسمية
                </Link>
                <Link to="#" className="dropdown-item">
                  حذف
                </Link>
              </div>
            </div>
            <div className="card-file-thumb text-primary">
              <i className={file.icon} />
            </div>
            <div className="card-body">
              <h6>
                <Link to="#">{file.fileName}</Link>
              </h6>
              <span>{file.fileSize}</span>
            </div>
            <div className="card-footer">
              <span className="d-none d-sm-inline">Last Modified: </span>
              {file.lastModified}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RecentFiles;
